/** The 12-hour cap the backend applies to one session; shown the same so the screen never reads longer than the record. */
export const MAX_SESSION_MS = 12 * 3_600_000

/** "5:09", "1:05:09": a running clock. */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000))
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`
}

/** "45m", "2h 05m", "0m": time already logged. Under a minute reads as "<1m" so a real session never shows as nothing. */
export function formatLogged(ms: number): string {
  if (ms <= 0) return '0m'
  const minutes = Math.floor(ms / 60_000)
  if (minutes < 1) return '<1m'
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  return h > 0 ? `${h}h ${String(m).padStart(2, '0')}m` : `${m}m`
}

/**
 * How long a running session has run, using the server's clock as the reference so a laptop whose
 * clock is minutes off still shows the same elapsed time as everyone else's screen.
 */
export function elapsedMs(startedAt: string, serverNow: string, fetchedAt: number, clientNow: number): number {
  const offset = Date.parse(serverNow) - fetchedAt
  const start = Date.parse(startedAt)
  if (!Number.isFinite(start) || !Number.isFinite(offset)) return 0
  return Math.min(MAX_SESSION_MS, Math.max(0, clientNow + offset - start))
}
